import { useAuth } from '@/hooks/useAuth';
import { Navigate, Outlet } from 'react-router-dom';

export function RedirectAuthenticatedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="bg-background min-h-screen" />;
  }

  if (isAuthenticated) {
    return <Navigate to="/perfil" replace />;
  }

  return <Outlet />;
}
